import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onError", "src"];
var __jsx = React.createElement;
import React, { useRef, useEffect, useCallback } from "react";
import useIsMobile from "@hooks/useIsMobile";
import { BROKEN_IMAGE_MOBILE, BROKEN_IMAGE_DESKTOP } from "@globalConfig";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
var checkImageSrc = function checkImageSrc(originalSrc) {
  if (!originalSrc) return originalSrc;
  if (checkFeatureFlag("FF_CDN_VERSION_V2")) {
    return originalSrc.replaceAll("?v=1", "?v=2");
  }
  return originalSrc;
};
var CarImage = function CarImage(_ref) {
  var onError = _ref.onError,
    src = _ref.src,
    props = _objectWithoutProperties(_ref, _excluded);
  var isMobile = useIsMobile();
  var hasErrorRef = useRef(false);
  var placeholderUrl = isMobile ? BROKEN_IMAGE_MOBILE || BROKEN_IMAGE_DESKTOP : BROKEN_IMAGE_DESKTOP || BROKEN_IMAGE_MOBILE;
  useEffect(function () {
    hasErrorRef.current = false;
  }, [src]);
  var handleError = useCallback(function (e) {
    if (!hasErrorRef.current && placeholderUrl) {
      hasErrorRef.current = true;
      e.currentTarget.src = placeholderUrl;
    }
    onError === null || onError === void 0 ? void 0 : onError(e);
  }, [placeholderUrl, onError]);
  return /*#__PURE__*/React.createElement("img", _extends({
    src: checkImageSrc(src),
    onError: handleError
  }, props));
};
export default CarImage;